<template>
  
    <div class="flex flex-column pl-2 pr-2">
  
        <div class="mt-2 mb-2 flex align-items-center flex-column md:justify-content-start md:flex-row">
          <h2 class="">VYHĽADÁVANIE A REZERVÁCIA KUSOV</h2>
        </div>

        <ReservedItems :orderId="String(-1)" :reserved="true" :search="true"></ReservedItems>
        <ConfirmDialog></ConfirmDialog>
    </div>
</template>

<script lang="ts">

import {store} from "@/components/store";
import Security from "@/components/security";
import ReservedItems from "@/components/ReservedItems.vue";

export default {
  components: {
    ReservedItems,


  },
  name: "SearchStockItems",
  data() {
    return {
      store,
    }
  },

  mounted() {
   
   if (Security.requireToken()){
     store.selectModul = this.$route.path.split("/")[1]
     //this.routeParams = this.$route.params

     //this.loadData()


   }
 },

}
</script>